export default "__VITE_ASSET__Ca8e3qES__"